import { get } from 'lodash'
import { dateFormat } from '@/utils/date'
import { DATE_FORMAT } from '@/constant/date'

export const transformMassUpdatePayload = (payload) => {
  const actualDate = get(payload, 'actual_date')
  return {
    section_name: get(payload, 'task.[0]'),
    task_name: get(payload, 'task.[1]'),
    order_ids: get(payload, 'orderId'),
    current_status: get(payload, 'status.value'),
    actual_date: dateFormat(actualDate, DATE_FORMAT.YYYYMMDD),
  }
}
